// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-table[data-v-4a5b2f9e] .el-table__fixed-body-wrapper {\n  top: 30px !important;\n}\n", ""]);
// Exports
module.exports = exports;
